import React, { Component } from 'react';
import Media from 'react-media';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Logo } from '@tillersystems/stardust';
import breakpoint from 'styled-components-breakpoint';
import posed, { PoseGroup } from 'react-pose';

import { StepMenu, Theme, Dropdown } from '..';

const { string } = PropTypes;
/**
 * Header
 *
 * This component is in charge of displaying
 * the app header
 *
 * @return {jsx}
 */

class Header extends Component {
  state = {
    show: false,
  };

  /**
   * PropTypes Validation
   */
  static propTypes = {
    className: string,
  };

  /**
   * Default Props
   */
  static defaultProps = {
    className: '',
  };

  handleClick = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  };

  render() {
    const { className } = this.props;
    const { show } = this.state;
    return (
      <header className={className}>
        <Media query={{ maxWidth: Theme.breakpoints.md }}>
          {matches =>
            matches ? (
              <React.Fragment>
                <Logo color={Theme.palette.darkBlue} width="103" height="28" />
                <StepMenu show={show} handleClick={this.handleClick} />
                <PoseGroup>{show && <DropdownAnimation key="DropdownAnimation" />}</PoseGroup>
              </React.Fragment>
            ) : (
              <Logo color={Theme.palette.darkBlue} width="116" height="32" />
            )
          }
        </Media>
      </header>
    );
  }
}

const DropdownAnimation = posed(Dropdown)({
  enter: {
    opacity: 1,
    scaleY: 1,
    translateY: 0,
  },
  exit: {
    opacity: 0,
    scaleY: 0.4,
    translateY: -10,
    transition: {
      opacity: { ease: 'easeOut', duration: 250 },
      scaleY: { ease: 'easeOut', duration: 350 },
    },
  },
});

export default styled(Header)`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  width: 100%;
  height: 6rem;

  padding: 0 1.6rem;

  background: ${({ theme: { palette } }) => palette.white};

  border-bottom: 1px solid ${({ theme: { palette } }) => palette.lightGrey};
  position: relative;
  /* For small devices */
  ${breakpoint('xs', 'md')`
    justify-content: space-between;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/Header/index.js